import { useDraggable } from "@dnd-kit/core";
import type { BlockType } from "@babackapp/blocks-editor/types";
import { ReactNode } from "react";
import type { BlockDragData } from "./dnd-context";
import { LucideProps } from "lucide-react";

interface DraggableBlockProps {
  blockType: BlockType;
  title: string;
  description: string;
  icon: React.FC<LucideProps>;
  children: ReactNode;
}

export function DraggableBlock({
  blockType,
  title,
  description,
  icon,
  children,
}: DraggableBlockProps) {
  const dragData: BlockDragData = {
    blockType,
    title,
    description,
    icon,
  };

  const { attributes, listeners, setNodeRef, isDragging } = useDraggable({
    id: `block-${blockType}`,
    data: dragData,
  });

  return (
    <div
      ref={setNodeRef}
      {...listeners}
      {...attributes}
      style={{ cursor: isDragging ? "grabbing" : "grab", flex: 1 }}
    >
      {children}
    </div>
  );
}
